export enum NAME_CONTRACT {
	PROCESSED_OFFER_LETTERS = 'processed_offer_letters',
	CONTRACTS = 'contracts',
	ADDITIONAL_AGREEMENTS = 'additional_agreements',
	DRAFTS = 'drafts',
	OTHERS = 'others',
	TERMINATIONS = 'terminations',
}

export const TYPE_CONTRACT = {
	[NAME_CONTRACT.PROCESSED_OFFER_LETTERS]: {
		linkedContracts: false,
		createTag: false,
	},
	[NAME_CONTRACT.CONTRACTS]: {
		linkedContracts: false,
		createTag: false,
	},
	[NAME_CONTRACT.ADDITIONAL_AGREEMENTS]: {
		linkedContracts: true,
		createTag: true,
	},
	[NAME_CONTRACT.DRAFTS]: {
		linkedContracts: true,
		createTag: true,
	},
	[NAME_CONTRACT.OTHERS]: {
		linkedContracts: true,
		createTag: true,
	},
	[NAME_CONTRACT.TERMINATIONS]: {
		linkedContracts: true,
		createTag: true,
	},
}

export const TYPE_OFFER_CONTRACT = [NAME_CONTRACT.PROCESSED_OFFER_LETTERS, NAME_CONTRACT.CONTRACTS]
